export function removerMascara(valor) {
  if (!valor) return "";
  
  return String(valor).replace(/[.-]/g, "");
}

export function formatarCarteirinha(valor) {
  if (!valor) return "";

  const limpo = String(valor).replace(/\D/g, "");

  return limpo.replace(/^(\d{4})(\d{4})(\d{6})(\d{2})(\d{1}).*/, "$1.$2.$3.$4-$5");
}